import { api } from '../services/axiosConfig';

export interface HubDistance {
  key: 'jita' | 'amarr' | 'hek' | 'dodixie';
  name: string;
  /** null = no gate route (w-space, Pochven, Zarzakh). */
  jumps: number | null;
}

export interface ConstellationSystem {
  solarSystemId: number;
  name: string;
  securityStatus: number | null;
  shipKills: number;
  podKills: number;
  npcKills: number;
}

export interface NearbySkyhook {
  planetId: number;
  solarSystemId: number;
  planetName: string;
  systemName: string;
  regionName: string | null;
  jumps: number;
  vulnerableFrom: string;
  vulnerableUntil: string;
  open: boolean;
  minutesUntilOpen: number;
  minutesRemaining: number;
}

export interface ScoutConnection {
  hub: 'Thera' | 'Turnur';
  exitSystemId: number;
  exitSystemName: string;
  whType: string | null;
  remainingHours: number | null;
  jumps: number;
}

export interface KspaceIntel {
  securityBand: 'highsec' | 'lowsec' | 'nullsec' | 'unknown';
  securityStatus: number | null;
  sovereignty: { allianceName: string | null; corporationName: string | null; factionName: string | null } | null;
  hubs: HubDistance[];
  kills: { shipKills: number; podKills: number; npcKills: number } | null;
  constellation: {
    id: number | null;
    systems: ConstellationSystem[];
    totals: { shipKills: number; podKills: number; npcKills: number };
  };
  nearbySkyhooks: NearbySkyhook[];
  nearestScoutConnection: ScoutConnection | null;
}

export const fetchKspaceIntel = (solarSystemId: number) =>
  api.get<KspaceIntel>(`/api/intel/kspace/${solarSystemId}`).then((r) => r.data);

/** "1h 24m" / "9m" — a raid window is minutes-to-hours. */
export function formatMinutes(total: number): string {
  if (total < 60) return `${total}m`;
  const h = Math.floor(total / 60);
  const m = total % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

export const SECURITY_BAND_LABEL: Record<KspaceIntel['securityBand'], string> = {
  highsec: 'High Sec',
  lowsec: 'Low Sec',
  nullsec: 'Null Sec',
  unknown: 'Unknown',
};
